import { DateTime } from "luxon";

// Collection windows arrive as calendar dates but are compared against pay period bounds as
// instants, so each boundary is anchored to the company-local edge of its day.
export const anchorCollectionBoundary = ({
	date,
	timezone,
	boundary,
}: {
	date: string;
	timezone: string;
	boundary: "start" | "end";
}): string => {
	const local = DateTime.fromISO(date, { zone: timezone });
	return (boundary === "start" ? local : local.endOf("day")).toUTC().toISO() ?? date;
};

export const anchorCollectionWindow = ({
	startDate,
	endDate,
	timezone,
}: {
	startDate: string;
	endDate?: string | null;
	timezone: string;
}): { startDate: string; endDate: string | undefined } => ({
	startDate: anchorCollectionBoundary({ date: startDate, timezone, boundary: "start" }),
	endDate: endDate ? anchorCollectionBoundary({ date: endDate, timezone, boundary: "end" }) : undefined,
});
